import { track } from "jiffy-analytics";
import { EventBus, Events } from "jiffy-store";
import { FreeShippingProgressController } from "components/jiffy/free-shipping-progress/free-shipping-progress";
import { formatCurrency } from "common/utils/format/number";
import initBogoBlanksRecommendations from "components/jiffy/bogo-blanks-recommendations/bogo-blanks-recommendations";
import "./bogo-atc-modal.scss";

const MODAL_OPENED_EVENT = "added_to_cart_modal_opened";
const MODAL_TYPE = "Free Transfers - DTF PDP";

const progressBarController = new FreeShippingProgressController("#bogo-atc-modal");

const getElements = (() => {
  let $cachedModal = null;

  return {
    get $$modal() {
      return $(this.$modal);
    },

    get $modal() {
      $cachedModal ??= document.getElementById("bogo-atc-modal");
      return $cachedModal;
    },

    get $continueButton() {
      return this.$modal?.querySelector(".js-bogo-atc-modal-continue");
    },

    get $viewCartLink() {
      return this.$modal?.querySelector(".js-bogo-atc-modal-view-cart");
    },

    get $closeButton() {
      return this.$modal?.querySelector(".js-close-bogo-atc-modal");
    },

    get $shopBlanksLink() {
      return this.$modal?.querySelector(".js-bogo-atc-modal-shop-blanks");
    },

    get $signupLink() {
      return this.$modal?.querySelector(".js-bogo-atc-modal-signup-link");
    },

    get $savings() {
      return this.$modal?.querySelector(".js-bogo-atc-modal-savings");
    }
  };
})();

let initialized = false;

const initEventListeners = () => {
  if (initialized) return;
  initialized = true;

  getElements.$continueButton?.addEventListener("click", () => {
    track("cta_click", { destination: "continue_shopping" });
    getElements.$$modal.modal("hide");
  });

  getElements.$viewCartLink?.addEventListener("click", () => {
    track("cta_click", { destination: "view_cart" });
  });

  getElements.$closeButton?.addEventListener("click", () => {
    track("cta_click", { destination: "close_modal" });
  });

  getElements.$shopBlanksLink?.addEventListener("click", () => {
    track("cta_click", { destination: "shop_blanks_save" });
  });

  getElements.$signupLink?.addEventListener("click", () => {
    track("cta_click", { destination: "create_account" });
  });
};

const updateProgressBar = target => {
  const {
    free_shipping_threshold: shippingThreshold,
    sub_order_total: total,
    show_free_shipping_with_account: showFreeShippingWithAccount,
    success
  } = target;

  progressBarController.hideSpinner();

  if (success) {
    progressBarController.updateProgressBar({
      total,
      threshold: shippingThreshold,
      showFreeShippingWithAccount
    });
  }
};

const updateSavings = potentialBogoSavings => {
  const { $savings, $shopBlanksLink } = getElements;
  const savings = parseFloat(potentialBogoSavings);
  const isValidSavings = !Number.isNaN(savings) && savings > 0;

  if ($shopBlanksLink) {
    $shopBlanksLink.hidden = !isValidSavings;
  }

  if ($savings && isValidSavings) {
    $savings.textContent = formatCurrency(savings);
  }
};

const showBogoAtcModal = target => {
  const { $$modal } = getElements;
  if (!$$modal.length) return;

  if (target) {
    updateProgressBar(target);
    updateSavings(target.potential_bogo_savings);
  }

  $$modal.modal("show");
  initEventListeners();
  initBogoBlanksRecommendations();
  track(MODAL_OPENED_EVENT, { modal_type: MODAL_TYPE });
};

const initBogoAtcModal = () => {
  EventBus.on(Events.SHOW_BOGO_ATC_MODAL, ({ target } = {}) => {
    showBogoAtcModal(target);
  });
};

export default initBogoAtcModal;
